<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/qTkIxn/tc-custom/9781429966115.jpg?1737767665829" alt="This image is the cover for the book The Dinosaur Lords"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Dinosaur Lords
      </h1>
      <p class="bookDescription body article font2">
        <b>This epic fantasy debut plunges readers into a gritty world of court intrigue and dinosaur battles: “a cross between <i>Jurassic Park</i> and <i>Game of Thrones</i>” (George R. R. Martin).</b><br/><br/>Paradise is a sprawling, diverse, often brutal place—one formed by the Eight Creators to play out their games of passion and power. In Paradise, lords and ladies vie for power as dinosaurs range the land and take the skies. And while some of these fearsome creatures run wild, others are harnessed as weapons of war.<br/><br/>Thus we are plunged into Victor Milán’s world of <i>The Dinosaur Lords</i>, a place of dynastic rivalries, religious wars, and byzantine politics, and clashing armies of dinosaur-mounted knights. During the course of one of these epic battles, the mercenary Dinosaur Lord Karyl Bogomirsky is defeated through betrayal and left for dead. He wakes, naked, wounded, partially amnesiac—and hunted. And embarks upon a journey that will shake his world.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Victor Milán
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4fa3a06a